import React from 'react';
import './AppWalletRequiredPrompt.css';

function AppWalletRequiredPrompt({ threshold = 0.1, onClose, onActivate }) {
  return (
    <div className="app-wallet-required-overlay" onClick={onClose}>
      <div
        className="app-wallet-required-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="app-wallet-required-header">
          <h3>Active Wallet Required</h3>
        </div>

        <div className="app-wallet-required-body">
          <p>
            To register an app on BarterFi, your main account must first activate
            its in-app wallet.
          </p>

          <p>
            Please make an initial deposit of at least <strong>{threshold} Pi</strong>.
            This helps confirm that you are using a real KYC-verified Pi wallet.
          </p>

          <p className="app-wallet-required-note">
            Once your wallet is active, come back and continue your app registration.
          </p>
        </div>

        <div className="app-wallet-required-actions">
          <button
            type="button"
            className="app-wallet-required-secondary"
            onClick={onClose}
          >
            Not Now
          </button>

          <button
            type="button"
            className="app-wallet-required-primary"
            onClick={onActivate}
          >
            Activate Wallet
          </button>
        </div>
      </div>
    </div>
  );
}

export default AppWalletRequiredPrompt;
